import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../ThemeContext';
import {
  HomeIcon,
  FolderIcon,
  QuestionMarkCircleIcon,
  DocumentTextIcon,
  UserCircleIcon,
  BellAlertIcon,
  ChartBarIcon,
  CalendarDaysIcon,
  ShieldCheckIcon,
  DocumentChartBarIcon
} from '@heroicons/react/24/outline';

function SideMenu() {
  const navigate = useNavigate();
  const { theme } = useTheme(); // Use the theme context
  const localStorageData = JSON.parse(localStorage.getItem("user"));
  const role = localStorageData?.authority;

  // Set styles based on the theme
  const bgClass = theme === 'light' ? 'bg-gray-100 text-gray-800' : 'bg-gray-800 text-white';
  const hoverClass = theme === 'light' ? 'hover:bg-gray-700 hover:text-white' : 'hover:bg-gray-700 hover:text-white';
  const activeClass = theme === 'light' ? 'bg-gray-700 text-white' : 'bg-gray-700 text-white';

  const isActive = (path) => location.pathname.split("/").includes(path) ? location.pathname.split("/").includes(path) : location.pathname === path;

  return (
    <div className={`h-full flex-col justify-between ${bgClass} hidden lg:flex`}>
      <div className="px-4 py-4">
        <nav aria-label="Main Nav" className="mt-6 flex flex-col space-y-1">
          <Link
            to="/"
            className={`flex items-center gap-2 rounded-sm ${isActive("/") ? activeClass : hoverClass} px-4 py-2`}
          >
            <ChartBarIcon className="h-5 w-5" />
            <span className="text-sm font-medium"> Dashboard </span>
          </Link>

          <Link
            to="/Projects"
            className={`flex items-center gap-2 rounded-sm ${isActive("Projects") ? activeClass : hoverClass} px-4 py-2`}
          >
            <FolderIcon className="h-5 w-5" />
            <span className="text-sm font-medium"> Project Management</span>
          </Link>

          {role === "superadmin" && (
            <Link
              to="/Users"
              className={`flex items-center gap-2 rounded-sm ${isActive("Users") ? activeClass : hoverClass} px-4 py-2`}
            >
              <UserCircleIcon className="h-5 w-5" />
              <span className="text-sm font-medium"> Users </span>
            </Link>
          )}

          <Link
            to="/Rfis"
            className={`flex items-center gap-2 rounded-sm ${isActive("Rfis") ? activeClass : hoverClass} px-4 py-2`}
          >
            <QuestionMarkCircleIcon className="h-5 w-5" />
            <span className="text-sm font-medium"> RFIs </span>
          </Link>

          <Link
            to="/Issues"
            className={`flex items-center gap-2 rounded-sm ${isActive("Issues") ? activeClass : hoverClass} px-4 py-2`}
          >
            <DocumentTextIcon className="h-5 w-5" />
            <span className="text-sm font-medium"> Issues </span>
          </Link>

          <Link
            to="/Alerts"
            className={`flex items-center gap-2 rounded-sm ${isActive("Alerts") ? activeClass : hoverClass} px-4 py-2`}
          >
            <BellAlertIcon className="h-5 w-5" />
            <span className="text-sm font-medium"> Alerts </span>
          </Link>

          <Link
            to="/Meetings"
            className={`flex items-center gap-2 rounded-sm ${isActive("Meetings") ? activeClass : hoverClass} px-4 py-2`}
          >
            <CalendarDaysIcon className="h-5 w-5" />
            <span className="text-sm font-medium"> Meetings </span>
          </Link>

          <Link
            to="/QA"
            className={`flex items-center gap-2 rounded-sm ${isActive("QA") ? activeClass : hoverClass} px-4 py-2`}
          >
            <ShieldCheckIcon className="h-5 w-5" />
            <span className="text-sm font-medium"> Quality Inspection </span>
          </Link>

          <Link
            to="/Reports"
            className={`flex items-center gap-2 rounded-sm ${isActive("Reports") ? activeClass : hoverClass} px-4 py-2`}
          >
            <DocumentChartBarIcon className="h-5 w-5" />
            <span className="text-sm font-medium">Reports</span>
          </Link>
        </nav>
      </div>
    </div>
  );
}

export default SideMenu;
